const mapPostData = post => {
  if (post.date) return post;
  return {
    date: post.taken_at_timestamp,
    caption: post.edge_media_to_caption.edges[0].node.text,
    likes: {
      count: post.edge_liked_by.count,
    },
    comments: {
      count: post.edge_media_to_comment.count,
    },
    display_src: post.thumbnail_resources[4].src,
  };
};

module.exports = {
  mapPostData,
};



/** WEBPACK FOOTER **
 ** ./src/utils/instagram.js
 **/